import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, _toConsumableArray(params));
  }
  return !!_useErrorBoundary;
}
export { shouldThrowError };